/** RBAC: admin = tudo, agent = visualizar+editar+exportar, viewer = só visualizar */
export function canViewContacts(user) {
  return !!user;
}

export function canEditContacts(user) {
  return user?.role === 'admin' || user?.role === 'agent';
}

export function canExportContacts(user) {
  return user?.role === 'admin' || user?.role === 'agent';
}
